import { render, staticRenderFns } from "./CompaniesUpdateDoc.vue?vue&type=template&id=8a69c2c6"
import script from "./CompaniesUpdateDoc.vue?vue&type=script&lang=js"
export * from "./CompaniesUpdateDoc.vue?vue&type=script&lang=js"
import style0 from "./CompaniesUpdateDoc.vue?vue&type=style&index=0&id=8a69c2c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports